export function AppLogo({ compact = false }: { compact?: boolean }) {
  return (
    <div className="flex items-center gap-2">
      <img
        src="/logo.png"
        alt="Landoo logo"
        width={36}
        height={36}
        className="h-9 w-9 shrink-0 object-contain"
        loading="eager"
        decoding="async"
      />
      {!compact && (
        <div className="leading-tight">
          <div className="text-lg font-bold tracking-tight text-brown-dark">Landoo</div>
          <div className="text-[10px] uppercase tracking-widest text-muted-foreground">
            Map-first real estate
          </div>
        </div>
      )}
    </div>
  );
}
